export const fetchWithRetry = async (url, options) => {
  let retry = (options && options.retry) || 3;

  while (retry > 0) {
    try {
      return await fetch(url, options);
    } catch (e) {
      if (options && options.callback) {
        options.callback(retry);
      }
      retry = retry - 1;

      if (retry === 0) {
        throw e;
      }
      if (options && options.pause) {
        await sleep(options.pause);
      }
    }
  }
};

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
